import { SENSOR_STATUS_ABNORMAL, SENSOR_STATUS_ALERT, SENSOR_STATUS_ATTENTION, SENSOR_STATUS_GATE_CLOSED, SENSOR_STATUS_GATE_OPENED, SENSOR_STATUS_NORMAL } from 'constants/config';
import { TEXT_BUTTON_CREATE, TEXT_BUTTON_UPDATE, TEXT_CANCEL, TEXT_GROUP_NAME, TEXT_SENSOR_CAMERA, TEXT_SENSOR_FLOOD, TEXT_SENSOR_FLOOD_GATE, TEXT_SENSOR_GENERAL, TEXT_SENSOR_TYPE } from 'constants/message';
import { SensorType } from 'models';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import "./ModifyGroupForm.css";

const SENSOR_STATUS_NORMAL_VALUE = 13;
const SENSOR_STATUS_ALERT_VALUE = 11;
const SENSOR_STATUS_ATTENTION_VALUE = 7;

const FLOOD_GATE_STATUSES = [
  SENSOR_STATUS_GATE_CLOSED,
  SENSOR_STATUS_GATE_OPENED,
  SENSOR_STATUS_ALERT,
  SENSOR_STATUS_ABNORMAL
]

const CAMERA_STATUSES = [
  SENSOR_STATUS_NORMAL,
  SENSOR_STATUS_ABNORMAL
]

const GENERAL_STATUSES = [
  SENSOR_STATUS_NORMAL,
  SENSOR_STATUS_ALERT,
  SENSOR_STATUS_ABNORMAL
]


const propTypes = {
  group: PropTypes.object,
  onModify: PropTypes.func,
  onCancel: PropTypes.func
};
const defaultProps = {
  group: {},
  onModify: (newGroup) => { },
  onCancel: () => { }
};
const ModifyGroupForm = (props) => {
  /*** States and Variables ***/
  const {
    register, handleSubmit, watch
  } = useForm();
  const initGroup = props.group;
  /*** Processing ***/
  /*** Sub Components ***/
  const renderMessageSetting = () => {
    return <>
      <div className='modify_group_form_message_setting_row'>
        {(watch('type', initGroup.type || SensorType.FLOOD) === SensorType.FLOOD) && <>
          <div className='modify_group_form_message_setting_bit_cell'>
            接点1
          </div>
          <div className='modify_group_form_message_setting_bit_cell'>
            接点2
          </div>
          <div className='modify_group_form_message_setting_bit_cell'>
            接点3
          </div>
          <div className='modify_group_form_message_setting_bit_cell'>
            接点4
          </div>
        </>}
        <div className='modify_group_form_message_setting_status_cell modify_group_label'>
          ステータス
        </div>
        <div className='modify_group_form_message_setting_color_cell modify_group_label'>
          色
        </div>
        <div className='modify_group_form_message_setting_message_cell'>
          メッセージ
        </div>
      </div>
      <div className='modify_group_form_message_setting_separator' />
      {watch('type', initGroup.type || SensorType.FLOOD) === SensorType.FLOOD ? Array.from({ length: 16 }).map((_, i) => {
        const defaultStatus = (i === SENSOR_STATUS_NORMAL_VALUE && SENSOR_STATUS_NORMAL) || (i === SENSOR_STATUS_ALERT_VALUE && SENSOR_STATUS_ALERT) || (i === SENSOR_STATUS_ATTENTION_VALUE && SENSOR_STATUS_ATTENTION) || SENSOR_STATUS_ABNORMAL;
        const targetMessage = initGroup?.messages && initGroup.messages[i];
        let statusText = targetMessage?.status;
        statusText = statusText || statusText === '' ? statusText : defaultStatus;
        const defaultStatusVal = targetMessage?.value || statusText;
        return <>
          <div
            key={'FLOOD_' + i}
            className='modify_group_form_message_setting_row'>
            <div className='modify_group_form_message_setting_bit_cell'>
              {(i & 0b1000) >> 3}
            </div>
            <div className='modify_group_form_message_setting_bit_cell'>
              {(i & 0b0100) >> 2}
            </div>
            <div className='modify_group_form_message_setting_bit_cell'>
              {(i & 0b0010) >> 1}
            </div>
            <div className='modify_group_form_message_setting_bit_cell'>
              {i & 0b0001}
            </div>
            <div className='modify_group_form_message_setting_status_cell'>
              <select
                className='modify_group_form_message_setting_status_select'
                defaultValue={defaultStatusVal}
                {...register(`messages.${i}.value`)}>
                <option value={SENSOR_STATUS_ABNORMAL}>{SENSOR_STATUS_ABNORMAL}</option>
                <option value={SENSOR_STATUS_NORMAL}>{SENSOR_STATUS_NORMAL}</option>
                <option value={SENSOR_STATUS_ATTENTION}>{SENSOR_STATUS_ATTENTION}</option>
                <option value={SENSOR_STATUS_ALERT}>{SENSOR_STATUS_ALERT}</option>
              </select>
              <input
                type='text'
                className='modify_group_form_status_input'
                defaultValue={statusText}
                {...register(`messages.${i}.status`)} />
            </div>
            <div className='modify_group_form_message_setting_color_cell'>
              <input
                type="color"
                className='modify_group_form_color_input'
                defaultValue={(initGroup?.messages && initGroup.messages[i] && initGroup.messages[i].color) || '#000000'}
                {...register(`messages.${i}.color`)} />
            </div>
            <div className='modify_group_form_message_setting_message_cell'>
              <input
                type='text'
                className='modify_group_form_message_input'
                defaultValue={(initGroup?.messages && initGroup.messages[i] && initGroup.messages[i].message) || ''}
                {...register(`messages.${i}.message`)} />
            </div>
          </div>
          <div
            key={'FLOOD_' + (16 * 2 + i)}
            className='modify_group_form_message_setting_separator' />
        </>
      }) : watch('type', initGroup.type || SensorType.FLOOD_GATE) === SensorType.FLOOD_GATE ?
        Array.from({ length: 4 }).map((_, i) => {
          const defaultStatus = (i === 0 && SENSOR_STATUS_GATE_CLOSED) || (i === 1 && SENSOR_STATUS_GATE_OPENED) || (i === 2 && SENSOR_STATUS_ALERT) || SENSOR_STATUS_ABNORMAL;
          const targetMessage = initGroup?.messages && initGroup.messages[16 + i];
          let statusText = targetMessage?.status;
          statusText = statusText || statusText === '' ? statusText : defaultStatus;
          const defaultStatusVal = targetMessage?.value || statusText;
          return <>
            <div
              key={'GATE_' + i}
              className='modify_group_form_message_setting_row'>
              <div className='modify_group_form_message_setting_status_cell'>
                <select
                  className='modify_group_form_message_setting_status_select'
                  disabled={true}
                  value={defaultStatusVal}
                  {...register(`messages.${16 + i}.value`)}>
                  {FLOOD_GATE_STATUSES.map(s => {
                    return <option value={s} key={s}>{s}</option>
                  })}
                </select>
                <input
                  type='text'
                  className='modify_group_form_status_input'
                  defaultValue={statusText}
                  {...register(`messages.${16 + i}.status`)} />
              </div>
              <div className='modify_group_form_message_setting_color_cell'>
                <input
                  type="color"
                  className='modify_group_form_color_input'
                  defaultValue={(initGroup?.messages && initGroup.messages[16 + i] && initGroup.messages[16 + i].color) || '#000000'}
                  {...register(`messages.${16 + i}.color`)} />
              </div>
              <div className='modify_group_form_message_setting_message_cell'>
                <input
                  type='text'
                  className='modify_group_form_message_input'
                  defaultValue={(initGroup?.messages && initGroup.messages[16 + i] && initGroup.messages[16 + i].message) || ''}
                  {...register(`messages.${16 + i}.message`)} />
              </div>
            </div>
            <div
              key={'GATE_' + 16 * 2 + i}
              className='modify_group_form_message_setting_separator' />
          </>
        }) : watch('type', initGroup.type || SensorType.CAMERA) === SensorType.CAMERA ? Array.from({ length: 2 }).map((_, i) => {
          const defaultStatus = (i === 0 && SENSOR_STATUS_NORMAL) || (i === 1 && SENSOR_STATUS_ABNORMAL);
          const targetMessage = initGroup?.messages && initGroup.messages[20 + i];
          const statusText = targetMessage?.status || defaultStatus
          const defaultStatusVal = targetMessage?.value || statusText;
          return <>
            <div
              key={'CAMERA_' + i}
              className='modify_group_form_message_setting_row'>
              <div className='modify_group_form_message_setting_status_cell'>
                <select
                  className='modify_group_form_message_setting_status_select'
                  disabled={true}
                  value={defaultStatusVal}
                  {...register(`messages.${20 + i}.value`)}>
                  {CAMERA_STATUSES.map(s => {
                    return <option value={s} key={s}>{s}</option>
                  })}
                </select>
                <input
                  type='text'
                  className='modify_group_form_status_input'
                  defaultValue={statusText}
                  {...register(`messages.${20 + i}.status`)} />
              </div>
              <div className='modify_group_form_message_setting_color_cell'>
                <input
                  type="color"
                  className='modify_group_form_color_input'
                  defaultValue={(initGroup?.messages && initGroup.messages[20 + i] && initGroup.messages[20 + i].color) || '#000000'}
                  {...register(`messages.${20 + i}.color`)} />
              </div>
              <div className='modify_group_form_message_setting_message_cell'>
                <input
                  type='text'
                  className='modify_group_form_message_input'
                  defaultValue={(initGroup?.messages && initGroup.messages[20 + i] && initGroup.messages[20 + i].message) || ''}
                  {...register(`messages.${20 + i}.message`)} />
              </div>
            </div>
            <div
              key={'CAMERA' + i * 2}
              className='modify_group_form_message_setting_separator' />
          </>
        }) : Array.from({ length: 3 }).map((_, i) => {
          const defaultStatus = GENERAL_STATUSES[i];
          const targetMessage = initGroup?.messages?.[22 + i];
          const statusText = targetMessage?.status || defaultStatus
          const defaultStatusVal = targetMessage?.value || defaultStatus;
          return <>
            <div
              key={'GENERAL_' + i}
              className='modify_group_form_message_setting_row'>
              <div className='modify_group_form_message_setting_status_cell'>
                <select
                  className='modify_group_form_message_setting_status_select'
                  disabled={true}
                  value={defaultStatusVal}
                  {...register(`messages.${22 + i}.value`)}>
                  {GENERAL_STATUSES.map(s => {
                    return <option value={s} key={s}>{s}</option>
                  })}
                </select>
                <input
                  type='text'
                  className='modify_group_form_status_input'
                  defaultValue={statusText}
                  {...register(`messages.${22 + i}.status`)} />
              </div>
              <div className='modify_group_form_message_setting_color_cell'>
                <input
                  type="color"
                  className='modify_group_form_color_input'
                  defaultValue={(initGroup?.messages && initGroup.messages[22 + i] && initGroup.messages[22 + i].color) || '#000000'}
                  {...register(`messages.${22 + i}.color`)} />
              </div>
              <div className='modify_group_form_message_setting_message_cell'>
                <input
                  type='text'
                  className='modify_group_form_message_input'
                  defaultValue={(initGroup?.messages && initGroup.messages[22 + i] && initGroup.messages[22 + i].message) || ''}
                  {...register(`messages.${22 + i}.message`)} />
              </div>
            </div>
            <div
              key={'GENERAL' + i * 2}
              className='modify_group_form_message_setting_separator' />
          </>
        })}
      <div className='modify_group_form_message_setting_row'>
        %sensor：センサ名称　%place：設置場所に置換します。
      </div>
      <div className='modify_group_form_message_setting_separator' />
    </>
  }
  /*** Event Handlers ***/
  const onSubmit = (data) => {
    if (initGroup.id) {
      data.id = initGroup.id;
    }
    if (initGroup.type === SensorType.FLOOD_GATE || data.type === SensorType.FLOOD_GATE) {
      for (let i = 0; i < FLOOD_GATE_STATUSES.length; i++) {
        data.messages[16 + i].value = FLOOD_GATE_STATUSES[i];
      }
    }
    if (initGroup.type === SensorType.CAMERA || data.type === SensorType.CAMERA) {
      for (let i = 0; i < CAMERA_STATUSES.length; i++) {
        data.messages[20 + i].value = CAMERA_STATUSES[i];
      }
    }
    if (initGroup.type === SensorType.GENERAL || data.type === SensorType.GENERAL) {
      for (let i = 0; i < GENERAL_STATUSES.length; i++) {
        data.messages[22 + i].value = GENERAL_STATUSES[i];
      }
    }
    props.onModify(data);
  }
  /*** Main Render ***/
  return <form
    onSubmit={handleSubmit(onSubmit)}
    className='modify_group_form_container'>
    <div className='modify_group_form_item_row'>
      <label className='modify_group_form_item_key'>
        {TEXT_SENSOR_TYPE}
      </label>
      <div className='modify_group_form_item_value'>
        <select
          className='modify_group_form_type_select'
          defaultValue={initGroup.type}
          disabled={!!initGroup.id}
          {...register('type')}>
          <option value={SensorType.FLOOD}>{TEXT_SENSOR_FLOOD}</option>
          <option value={SensorType.FLOOD_GATE}>{TEXT_SENSOR_FLOOD_GATE}</option>
          <option value={SensorType.GENERAL}>{TEXT_SENSOR_GENERAL}</option>
          <option value={SensorType.CAMERA}>{TEXT_SENSOR_CAMERA}</option>
        </select>
      </div>
    </div>
    <div className='modify_group_form_item_row'>
      <label className='modify_group_form_item_key'>
        {TEXT_GROUP_NAME}
      </label>
      <div className='modify_group_form_item_value'>
        <input
          type='text'
          defaultValue={initGroup.name}
          {...register('name')} />
      </div>
    </div>
    <div className='modify_group_form_item_row'>
      メッセージ設定
    </div>
    {renderMessageSetting()}
    <div className='modify_group_form_button_container'>
      <button className='modify_group_form_button button_active'>
        {props.group?.id ? TEXT_BUTTON_UPDATE : TEXT_BUTTON_CREATE}
      </button>
      <button
        type='button'
        className='modify_group_form_button button_cancel'
        onClick={props.onCancel}>
        {TEXT_CANCEL}
      </button>
    </div>
  </form>;
}
ModifyGroupForm.propTypes = propTypes;
ModifyGroupForm.defaultProps = defaultProps;
export default ModifyGroupForm;